/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  DeactivateFulfillmentPartnerErrorContract,
  ErrorApiOutContract,
  ErrorDescription,
  FulfillmentPartnerAdminApiContract,
  ProblemDetails
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Retrieves all active fulfillment partners.
 */
export const getAdminsFulfillmentpartners = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<FulfillmentPartnerAdminApiContract[]>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/fulfillmentpartners`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAdminsFulfillmentpartnersInfiniteQueryKey = () => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/admins/fulfillmentpartners`
    ] as const;
    }

export const getGetAdminsFulfillmentpartnersQueryKey = () => {
    return [
    `https://admins-api.api.quick.md/api/v1/admins/fulfillmentpartners`
    ] as const;
    }

    
export const getGetAdminsFulfillmentpartnersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsFulfillmentpartnersInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>> = ({ signal }) => getAdminsFulfillmentpartners(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsFulfillmentpartnersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>
export type GetAdminsFulfillmentpartnersInfiniteQueryError = void | ErrorApiOutContract


export function useGetAdminsFulfillmentpartnersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>,
          TError,
          Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>,
          TError,
          Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all active fulfillment partners.
 */

export function useGetAdminsFulfillmentpartnersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsFulfillmentpartnersInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves all active fulfillment partners.
 */
export const prefetchGetAdminsFulfillmentpartnersInfiniteQuery = async <TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsFulfillmentpartnersInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsFulfillmentpartnersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsFulfillmentpartnersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>> = ({ signal }) => getAdminsFulfillmentpartners(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsFulfillmentpartnersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>
export type GetAdminsFulfillmentpartnersQueryError = void | ErrorApiOutContract


export function useGetAdminsFulfillmentpartners<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>,
          TError,
          Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartners<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>,
          TError,
          Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartners<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all active fulfillment partners.
 */

export function useGetAdminsFulfillmentpartners<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsFulfillmentpartnersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves all active fulfillment partners.
 */
export const prefetchGetAdminsFulfillmentpartnersQuery = async <TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsFulfillmentpartnersQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsFulfillmentpartnersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsFulfillmentpartnersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>> = ({ signal }) => getAdminsFulfillmentpartners(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsFulfillmentpartnersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>
export type GetAdminsFulfillmentpartnersSuspenseQueryError = void | ErrorApiOutContract


export function useGetAdminsFulfillmentpartnersSuspense<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersSuspense<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersSuspense<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all active fulfillment partners.
 */

export function useGetAdminsFulfillmentpartnersSuspense<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsFulfillmentpartnersSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAdminsFulfillmentpartnersSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsFulfillmentpartnersInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>> = ({ signal }) => getAdminsFulfillmentpartners(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsFulfillmentpartnersSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>
export type GetAdminsFulfillmentpartnersSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetAdminsFulfillmentpartnersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves all active fulfillment partners.
 */

export function useGetAdminsFulfillmentpartnersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartners>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsFulfillmentpartnersSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Creates a new fulfillment partner with associated shipping options.
 */
export const postAdminsFulfillmentpartners = (
    fulfillmentPartnerAdminApiContract: FulfillmentPartnerAdminApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/fulfillmentpartners`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fulfillmentPartnerAdminApiContract, signal
    },
      options);
    }
  


export const getPostAdminsFulfillmentpartnersMutationOptions = <TError = ProblemDetails | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminsFulfillmentpartners>>, TError,{data: FulfillmentPartnerAdminApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminsFulfillmentpartners>>, TError,{data: FulfillmentPartnerAdminApiContract}, TContext> => {

const mutationKey = ['postAdminsFulfillmentpartners'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminsFulfillmentpartners>>, {data: FulfillmentPartnerAdminApiContract}> = (props) => {
          const {data} = props ?? {};

          return  postAdminsFulfillmentpartners(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminsFulfillmentpartnersMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminsFulfillmentpartners>>>
    export type PostAdminsFulfillmentpartnersMutationBody = FulfillmentPartnerAdminApiContract
    export type PostAdminsFulfillmentpartnersMutationError = ProblemDetails | void | ErrorApiOutContract

    /**
 * @summary Creates a new fulfillment partner with associated shipping options.
 */
export const usePostAdminsFulfillmentpartners = <TError = ProblemDetails | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminsFulfillmentpartners>>, TError,{data: FulfillmentPartnerAdminApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminsFulfillmentpartners>>,
        TError,
        {data: FulfillmentPartnerAdminApiContract},
        TContext
      > => {

      const mutationOptions = getPostAdminsFulfillmentpartnersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Retrieves specific fulfillment partner by ncpdpId.
 */
export const getAdminsFulfillmentpartnersNcpdpId = (
    ncpdpId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<FulfillmentPartnerAdminApiContract>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/fulfillmentpartners/${encodeURIComponent(String(ncpdpId))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAdminsFulfillmentpartnersNcpdpIdInfiniteQueryKey = (ncpdpId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/admins/fulfillmentpartners/${ncpdpId}`
    ] as const;
    }

export const getGetAdminsFulfillmentpartnersNcpdpIdQueryKey = (ncpdpId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/admins/fulfillmentpartners/${ncpdpId}`
    ] as const;
    }

    
export const getGetAdminsFulfillmentpartnersNcpdpIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>, TError = ProblemDetails | void | ErrorApiOutContract>(ncpdpId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsFulfillmentpartnersNcpdpIdInfiniteQueryKey(ncpdpId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>> = ({ signal }) => getAdminsFulfillmentpartnersNcpdpId(ncpdpId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ncpdpId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsFulfillmentpartnersNcpdpIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>
export type GetAdminsFulfillmentpartnersNcpdpIdInfiniteQueryError = ProblemDetails | void | ErrorApiOutContract


export function useGetAdminsFulfillmentpartnersNcpdpIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>,
          TError,
          Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersNcpdpIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>,
          TError,
          Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersNcpdpIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves specific fulfillment partner by ncpdpId.
 */

export function useGetAdminsFulfillmentpartnersNcpdpIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsFulfillmentpartnersNcpdpIdInfiniteQueryOptions(ncpdpId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves specific fulfillment partner by ncpdpId.
 */
export const prefetchGetAdminsFulfillmentpartnersNcpdpIdInfiniteQuery = async <TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 queryClient: QueryClient, ncpdpId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsFulfillmentpartnersNcpdpIdInfiniteQueryOptions(ncpdpId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsFulfillmentpartnersNcpdpIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError = ProblemDetails | void | ErrorApiOutContract>(ncpdpId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsFulfillmentpartnersNcpdpIdQueryKey(ncpdpId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>> = ({ signal }) => getAdminsFulfillmentpartnersNcpdpId(ncpdpId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(ncpdpId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsFulfillmentpartnersNcpdpIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>
export type GetAdminsFulfillmentpartnersNcpdpIdQueryError = ProblemDetails | void | ErrorApiOutContract


export function useGetAdminsFulfillmentpartnersNcpdpId<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>,
          TError,
          Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersNcpdpId<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>,
          TError,
          Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersNcpdpId<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves specific fulfillment partner by ncpdpId.
 */

export function useGetAdminsFulfillmentpartnersNcpdpId<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsFulfillmentpartnersNcpdpIdQueryOptions(ncpdpId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves specific fulfillment partner by ncpdpId.
 */
export const prefetchGetAdminsFulfillmentpartnersNcpdpIdQuery = async <TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 queryClient: QueryClient, ncpdpId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminsFulfillmentpartnersNcpdpIdQueryOptions(ncpdpId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetAdminsFulfillmentpartnersNcpdpIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError = ProblemDetails | void | ErrorApiOutContract>(ncpdpId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsFulfillmentpartnersNcpdpIdQueryKey(ncpdpId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>> = ({ signal }) => getAdminsFulfillmentpartnersNcpdpId(ncpdpId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsFulfillmentpartnersNcpdpIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>
export type GetAdminsFulfillmentpartnersNcpdpIdSuspenseQueryError = ProblemDetails | void | ErrorApiOutContract


export function useGetAdminsFulfillmentpartnersNcpdpIdSuspense<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersNcpdpIdSuspense<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersNcpdpIdSuspense<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves specific fulfillment partner by ncpdpId.
 */

export function useGetAdminsFulfillmentpartnersNcpdpIdSuspense<TData = Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsFulfillmentpartnersNcpdpIdSuspenseQueryOptions(ncpdpId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAdminsFulfillmentpartnersNcpdpIdSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>, TError = ProblemDetails | void | ErrorApiOutContract>(ncpdpId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminsFulfillmentpartnersNcpdpIdInfiniteQueryKey(ncpdpId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>> = ({ signal }) => getAdminsFulfillmentpartnersNcpdpId(ncpdpId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminsFulfillmentpartnersNcpdpIdSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>
export type GetAdminsFulfillmentpartnersNcpdpIdSuspenseInfiniteQueryError = ProblemDetails | void | ErrorApiOutContract


export function useGetAdminsFulfillmentpartnersNcpdpIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersNcpdpIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminsFulfillmentpartnersNcpdpIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves specific fulfillment partner by ncpdpId.
 */

export function useGetAdminsFulfillmentpartnersNcpdpIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>>, TError = ProblemDetails | void | ErrorApiOutContract>(
 ncpdpId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminsFulfillmentpartnersNcpdpId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminsFulfillmentpartnersNcpdpIdSuspenseInfiniteQueryOptions(ncpdpId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns 400 Bad Request with error code "FulfillmentPartnerSingleOptionForMedication" when
the partner is the only fulfillment option for one or more medications. The response body
includes an array of affected medication identifiers.
 * @summary Deactivates an existing fulfillment partner by NCPDP ID.
 */
export const deleteAdminsFulfillmentpartnersNcpdpId = (
    ncpdpId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/fulfillmentpartners/${encodeURIComponent(String(ncpdpId))}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAdminsFulfillmentpartnersNcpdpIdMutationOptions = <TError = DeactivateFulfillmentPartnerErrorContract | void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminsFulfillmentpartnersNcpdpId>>, TError,{ncpdpId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminsFulfillmentpartnersNcpdpId>>, TError,{ncpdpId: string}, TContext> => {

const mutationKey = ['deleteAdminsFulfillmentpartnersNcpdpId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminsFulfillmentpartnersNcpdpId>>, {ncpdpId: string}> = (props) => {
          const {ncpdpId} = props ?? {};

          return  deleteAdminsFulfillmentpartnersNcpdpId(ncpdpId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminsFulfillmentpartnersNcpdpIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminsFulfillmentpartnersNcpdpId>>>
    
    export type DeleteAdminsFulfillmentpartnersNcpdpIdMutationError = DeactivateFulfillmentPartnerErrorContract | void | ErrorDescription | ErrorApiOutContract

    /**
 * @summary Deactivates an existing fulfillment partner by NCPDP ID.
 */
export const useDeleteAdminsFulfillmentpartnersNcpdpId = <TError = DeactivateFulfillmentPartnerErrorContract | void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminsFulfillmentpartnersNcpdpId>>, TError,{ncpdpId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminsFulfillmentpartnersNcpdpId>>,
        TError,
        {ncpdpId: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdminsFulfillmentpartnersNcpdpIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Updates an existing fulfillment partner and its shipping options.
 */
export const putAdminsFulfillmentpartnersNcpdpId = (
    ncpdpId: string,
    fulfillmentPartnerAdminApiContract: FulfillmentPartnerAdminApiContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/admins/fulfillmentpartners/${encodeURIComponent(String(ncpdpId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fulfillmentPartnerAdminApiContract
    },
      options);
    }
  


export const getPutAdminsFulfillmentpartnersNcpdpIdMutationOptions = <TError = ProblemDetails | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsFulfillmentpartnersNcpdpId>>, TError,{ncpdpId: string;data: FulfillmentPartnerAdminApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminsFulfillmentpartnersNcpdpId>>, TError,{ncpdpId: string;data: FulfillmentPartnerAdminApiContract}, TContext> => {

const mutationKey = ['putAdminsFulfillmentpartnersNcpdpId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminsFulfillmentpartnersNcpdpId>>, {ncpdpId: string;data: FulfillmentPartnerAdminApiContract}> = (props) => {
          const {ncpdpId,data} = props ?? {};

          return  putAdminsFulfillmentpartnersNcpdpId(ncpdpId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminsFulfillmentpartnersNcpdpIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminsFulfillmentpartnersNcpdpId>>>
    export type PutAdminsFulfillmentpartnersNcpdpIdMutationBody = FulfillmentPartnerAdminApiContract
    export type PutAdminsFulfillmentpartnersNcpdpIdMutationError = ProblemDetails | void | ErrorApiOutContract

    /**
 * @summary Updates an existing fulfillment partner and its shipping options.
 */
export const usePutAdminsFulfillmentpartnersNcpdpId = <TError = ProblemDetails | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminsFulfillmentpartnersNcpdpId>>, TError,{ncpdpId: string;data: FulfillmentPartnerAdminApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminsFulfillmentpartnersNcpdpId>>,
        TError,
        {ncpdpId: string;data: FulfillmentPartnerAdminApiContract},
        TContext
      > => {

      const mutationOptions = getPutAdminsFulfillmentpartnersNcpdpIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    